import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';

// @transform-path ../../../../../../src/assets/csat/1.svg
import csat1 from '@/assets/csat/1.svg';
// @transform-path ../../../../../../src/assets/csat/2.svg
import csat2 from '@/assets/csat/2.svg';
// @transform-path ../../../../../../src/assets/csat/3.svg
import csat3 from '@/assets/csat/3.svg';
// @transform-path ../../../../../../src/assets/csat/4.svg
import csat4 from '@/assets/csat/4.svg';
// @transform-path ../../../../../../src/assets/csat/5.svg
import csat5 from '@/assets/csat/5.svg';

interface CSATProps {
  className?: string;
  label?: string;
  onPress?: (value: number) => void;
}

const ICON_SIZE = 40;

export const CSAT = ({
  className,
  label = 'How helpful was this?',
  onPress,
}: CSATProps) => {
  return (
    <Stack
      className={className}
      sx={{ alignItems: 'center', width: '100%', gap: sp[12] }}
    >
      {label && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            typography: 'bodyMd',
          }}
        >
          {label}
        </Box>
      )}
      <Stack
        direction='row'
        sx={{ justifyContent: 'space-between', gap: sp[8], width: '100%' }}
      >
        {[csat1, csat2, csat3, csat4, csat5].map((src, i) => (
          <Box
            key={i}
            onClick={() => onPress?.(i + 1)}
            sx={{
              cursor: 'pointer',
              width: `${ICON_SIZE}px`,
              height: `${ICON_SIZE}px`,
              minWidth: `${ICON_SIZE}px`,
              minHeight: `${ICON_SIZE}px`,
              maxWidth: `${ICON_SIZE}px`,
              maxHeight: `${ICON_SIZE}px`,
              transitionDuration: '200ms',
              '&:hover': { transform: 'scale(1.2)' },
              '& img': { width: '100%', height: '100%', objectFit: 'contain' },
            }}
          >
            <img src={src} alt={`${i + 1} out of 5`} />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

CSAT.displayName = 'CSAT';

export default CSAT;
